import { InputTypes } from '../../ui-inputs/validated-input';

export enum TagsFormFilterFieldWidth {
    FULL = 'full',
    HALF = 'half',
    QUARTER = 'quarter',
    AUTO = 'auto',
}

export interface TagsFormFilterField {
    key: string;
    label: string;
    type: TagsFormFiltersInputTypes;
    inputType?: InputTypes;
    placeholder?: string;
    defaultValue: any;
    options?: { label: string; value: any }[];
    width?: TagsFormFilterFieldWidth;
}

export enum TagsFormFiltersInputTypes {
    INPUT = 'input',
    DROPDOWN = 'dropdown',
    CHECKBOX = 'checkbox',
}
